import React from "react";
import { getLabel } from "../../../data/labels";
import { getHiddenTicket } from '../../utils/getHiddenTicket';

export default function SystemBetsDetailTicketHeader(props) {
    const ticketData = props.ticketData;
    let idTicketToShow = ticketData.idTicket;
    const frontendType = props.frontendType;
    const skinProperties = props.skinProperties;
	const user = props.user;
    const clearBoth = {clear: "both"};
    
    let printShopName = false;
	let shopName = null;
	if(frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER'){
		const mapKey = window.FUNZIONI_TERMINALE? window.FUNZIONI_TERMINALE.NOME_SHOP_SU_RICEVUTA : window.retailFunctions.SHOP_NAME_IN_TICKET;
		printShopName = skinProperties.functions[mapKey];
		if(printShopName){
			if(user.shopDescr != null && user.shopDescr !== ''){
				shopName = user.shopDescr;
			}
		}
		else{
			printShopName = false;
		}
	}

    if(ticketData.obfuscateTicketId && skinProperties && skinProperties.hideTerminalTicket){
            idTicketToShow = getHiddenTicket(idTicketToShow);
    }

    function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
    

    return (
        <>
            <div id="header-logos">
                <div id={"customer-logo" + (props.aamsLogo != null? "" : "-solo")}>
                {
                    props.customerLogo != null && props.customerLogo.length > 0 && (
                            <img src={props.customerLogo} />
                    )
                    
                }
                </div>
                {
                    props.aamsLogo != null &&(
                            <div id="aams-logo">
                                <img src={props.aamsLogo} />
                            </div>
                    )
                }
            </div>
            <div>
                <div style={clearBoth}><br/></div>
                <div className="td-100 left">{getLabel('printer.plain_ticket.header.id')}: {generateIdTicketWithBars(idTicketToShow)}</div>
                {
                (frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER') && printShopName && (	
                    <div>
                        <div className="td-100 left"> {getLabel('printer.plain_ticket.header.nc')} : {shopName} </div>
                        <div style={clearBoth}></div>
                    </div>
                )
                }
                <div style={clearBoth}><br/><br/></div>
            </div>
        </>
    )
}